import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumb from "../Components/Breadcrumb";
import UnderMaintanence from "./UnderMaintanence";
import Research_Publications from "../assets/PDF/Research/Research_Publications.pdf";

const sidemenus = [
  {
    title: "Code of Ethics",
    url: "/ResearchCenter/CodeEthics",
  },
  {
    title: "Research and Publications",
    url: "/ResearchCenter/Publications",
  },
];

export default function ResearchCenter(props) {
  const [menuName, setName] = useState(props.pageName);
  const [menuId, setId] = useState(props.pageId);

  useEffect(() => {
    setName(props.pageName);
    setId(props.pageId);
  }, [props.pageName, props.pageId]);

  useEffect(() => {
    // Remove active-menu class from all links first
    const allWithClass = Array.from(document.querySelectorAll(".sideMenu a"));
    allWithClass.forEach((element) => {
      element.classList.remove("active-menu");
    });

    let id = menuId.toString();
    let currentEl = document.getElementById(id);
    if (currentEl) {
      currentEl.setAttribute("class", "active-menu");
    }

    // Add d-none class for all divs
    sidemenus.forEach((element) => {
      let id = element.title.split(" ").join("").toString();
      let div = document.getElementById(id);
      if (div) div.classList.add("d-none");
    });

    // remove class d-none of particular div on click by getting Id
    let divId = menuName.split(" ").join("").toString();
    let activeDiv = document.getElementById(divId);
    if (activeDiv) activeDiv.classList.remove("d-none");

    // scroll top
    window.scrollTo(0, 0);
  }, [menuName, menuId]);

  const handleClick = (event) => {
    setName(event.currentTarget.textContent);
    setId(event.currentTarget.id);

    // Remove all class active-menu of '.sideMenu a' on click
    const allWithClass = Array.from(document.querySelectorAll(".sideMenu a"));

    allWithClass.forEach((element) => {
      element.classList.remove("active-menu");
    });
  };

  return (
    <>
      <Breadcrumb pageTitle={menuName} />
      <div className="container mt-3">
        <div className="row default-padding-bottom">
          {/* Sidebar */}
          <aside className="sideMenu col-lg-3">
            <div className="scroll-div">
              {sidemenus.map((menu, index) => {
                return (
                  <Link
                    key={index}
                    id={index}
                    onClick={handleClick}
                    to={menu.url}
                  >
                    {" "}
                    {menu.title}{" "}
                  </Link>
                );
              })}
            </div>
          </aside>
          {/* content */}
          <div className="col-lg-9">
            <div className="px-lg-3 px-1">
              {sidemenus.map((menu, index) => {
                return (
                  <div
                    id={menu.title.split(" ").join("").toString()}
                    key={index}
                  >
                    {props.pageContent}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// export function CodeEthics() {
//   return (
//     <div>
//       <UnderMaintanence />
//     </div>
//   );
// }

export function CodeEthics() {
  return (
    <div>
      <h5 className="title-text my-2 mb-4">Ph.D (Doctorate of Philosophy)</h5>
      <p>
        The Research Centre at P.E. Society's Modern Institute of Business
        Studies was established in 2005. Research center is affiliated with
        Savitribai Phule Pune University. It offers a Ph.D. program in
        Management. The center attracts students from diverse management
        backgrounds, including Marketing, Finance, Operations and Supply Chain
        Management, Human Resource Management, and Computer Management. The
        research center is committed to fostering academic excellence and
        innovation in the field of management studies.
      </p>
      <p>
        The Research Centre at P.E. Society's Modern Institute of Business
        Studies is known for its rigorous academic environment and strong
        emphasis on interdisciplinary research. Over the years, the center has
        contributed significantly to the academic and professional development
        of its students, many of whom have gone on to become leaders in their
        respective fields. The center's affiliation with Savitribai Phule Pune
        University further enhances its academic credibility and ensures that
        the research produced is of the highest standard. Admission Procedure
        for Ph.D. in Management is as per Savitribai Phule Pune University and
        UGC Guidelines.
      </p>
      <p>
        <strong>Eligibility:</strong> As per the norms given by Savitribai Phule
        Pune University and UGC guidelines
      </p>
      <p style={{ fontWeight:"bold"}}>Ph.D in following areas:</p>
      <div
        className="d-flex flex-column"
        style={{ gap: "12px", maxWidth: "500px" }}
      >
        <div
          style={{
            backgroundColor: "#f0923b",
            color: "#000",
            fontWeight: "bold",
            fontStyle: "italic",
            padding: "12px 20px",
            borderRadius: "6px",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          Marketing Management
        </div>
        <div
          style={{
            backgroundColor: "#4bb8c4",
            color: "#000",
            fontWeight: "bold",
            fontStyle: "italic",
            padding: "12px 20px",
            borderRadius: "6px",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          Financial Management
        </div>
        <div
          style={{
            backgroundColor: "#7d5ba6",
            color: "#000",
            fontWeight: "bold",
            fontStyle: "italic",
            padding: "12px 20px",
            borderRadius: "6px",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          Human Resources Management
        </div>
        <div
          style={{
            backgroundColor: "#a4c452",
            color: "#000",
            fontWeight: "bold",
            fontStyle: "italic",
            padding: "12px 20px",
            borderRadius: "6px",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          Operations &amp; Supply Chain Management
        </div>
        <div
          style={{
            backgroundColor: "#4a7fc1",
            color: "#000",
            fontWeight: "bold",
            fontStyle: "italic",
            padding: "12px 20px",
            borderRadius: "6px",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          Organization Management
        </div>
        <div
          style={{
            backgroundColor: "#0875fb",
            color: "#000",
            fontWeight: "bold",
            fontStyle: "italic",
            padding: "12px 20px",
            borderRadius: "6px",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          Computer Management
        </div>
      </div>
    </div>
  );
}

export function Publications() {
  return (
    <div>
      <h5 className="title-text my-2 mb-4">Research And Publications</h5>
      <div>
        <object
          // data="http://mibmpune.com/assets/Mandatory-Disclosure.pdf"
          data={Research_Publications}
          type="application/pdf"
          width="100%"
          height={800}
        >
          <p>Your web browser doesn't have a PDF plugin.</p>
          <p>
            Instead you can{" "}
            <Link to={Research_Publications}>
              {" "}
              click here to download the PDF file.
            </Link>
          </p>
        </object>
      </div>
    </div>
  );
}
